import _tmpl from "./badge.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Variant = /*#__PURE__*/function (Variant) {
  Variant["Default"] = "default";
  Variant["Outline"] = "outline";
  Variant["Filled"] = "filled";
  return Variant;
}({});
let Theme = /*#__PURE__*/function (Theme) {
  Theme["Default"] = "default";
  Theme["Blue"] = "blue";
  Theme["Red"] = "red";
  Theme["Pink"] = "pink";
  Theme["Indigo"] = "indigo";
  Theme["Teal"] = "teal";
  Theme["Purple"] = "purple";
  Theme["Green"] = "green";
  Theme["HotOrange"] = "hot-orange";
  Theme["Violet"] = "violet";
  Theme["Yellow"] = "yellow";
  return Theme;
}({});
class Badge extends LightningElement {
  constructor(...args) {
    super(...args);
    /*
     * Variants and themes
     */
    this.variant = Variant.Default;
    this.theme = Theme.Default;
    /*
     * getIconURL handles loading the icons
     */
    this.icon = void 0;
    this.iconDescription = void 0;
    /*
     * Text for the button
     */
    this.text = null;
  }
  get classes() {
    return classNames("element", {
      [`variant-${this.variant}`]: true,
      [`theme-${this.theme}`]: this.variant !== null
    });
  }
  get hasIcon() {
    return this.icon;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Badge, {
  publicProps: {
    variant: {
      config: 0
    },
    theme: {
      config: 0
    },
    icon: {
      config: 0
    },
    iconDescription: {
      config: 0
    },
    text: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Badge, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;